import { request } from './client.js';
import type { BookSubjectKind } from '@kitup/book-schema';

export interface BookSubjectDto {
  id: string;
  kind: BookSubjectKind;
  name: string;
  descriptionEn: string;
  approved: boolean;
  status: 'draft' | 'queued' | 'running' | 'ready' | 'failed';
  error: string | null;
  selectedVariantId: string | null;
  imageUrl: string | null;
  variants: { id: string; url: string }[];
  sceneIds: string[];
}
export interface CatalogReferenceDto {
  id: string;
  kind: 'object' | 'location';
  name: string;
  approved: boolean;
  imageUrl: string | null;
  sceneIds: string[];
  href: string;
}

export interface BookLookDto {
  id: string;
  characterId: string;
  characterName: string;
  name: string;
  descriptionEn: string;
  isBase: boolean;
  approved: boolean;
  status: 'draft' | 'queued' | 'running' | 'ready' | 'failed';
  error: string | null;
  selectedVariantId: string | null;
  imageUrl: string | null;
  variants: { id: string; url: string }[];
  sceneIds: string[];
}
export interface LooksDto {
  planStatus: 'none' | 'queued' | 'running' | 'ready' | 'failed' | 'stale';
  planError: string | null;
  ready: boolean;
  /** Spreads whose outfits and details are all drawn and approved. */
  readySceneIds: string[];
  items: BookLookDto[];
  subjects: BookSubjectDto[];
  catalogItems: CatalogReferenceDto[];
  scenes: { id: string; index: number; characterIds: string[] }[];
}
export const looksApi = {
  list: (bookId: string) => request<LooksDto>(`/books/${bookId}/looks`),
  plan: (bookId: string, guidance?: string) =>
    request(`/books/${bookId}/looks/generate`, { method: 'POST', body: { guidance } }),
  generate: (bookId: string, lookId: string) =>
    request(`/books/${bookId}/looks/${lookId}/generate`, { method: 'POST' }),
  approve: (bookId: string, lookId: string, variantId?: string) =>
    request(`/books/${bookId}/looks/${lookId}/approve`, { method: 'POST', body: { variantId } }),
  assign: (bookId: string, sceneId: string, characterId: string, lookId: string) =>
    request(`/books/${bookId}/looks/assignment`, {
      method: 'PATCH',
      body: { sceneId, characterId, lookId },
    }),
  continue: (bookId: string) =>
    request(`/books/${bookId}/looks/artwork/generate`, { method: 'POST' }),
  generateSubject: (bookId: string, subjectId: string) =>
    request(`/books/${bookId}/looks/subjects/${subjectId}/generate`, { method: 'POST' }),
  approveSubject: (bookId: string, subjectId: string, variantId?: string) =>
    request(`/books/${bookId}/looks/subjects/${subjectId}/approve`, {
      method: 'POST',
      body: { variantId },
    }),
};
